import * as React from "react";

function SvgDropMedia(props) {
  return <svg width={68} height={66} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M34 .458C15.378.458.238 15.151.238 33.223c0 18.072 15.14 32.765 33.762 32.765 18.621 0 33.761-14.693 33.761-32.765C67.761 15.15 52.621.458 34 .458zm0 59.386c-15.14 0-27.431-11.928-27.431-26.621C6.569 18.53 18.859 6.6 33.999 6.6S61.432 18.53 61.432 33.223 49.14 59.844 34 59.844zm-7.913-12.798V19.4l22.156 13.823-22.156 13.823z" fill="#000" fillOpacity={0.54} /></svg>;
}

export default SvgDropMedia;